import React, { memo } from "react";

interface IStopIconProps {
  size?: number;
}

const StopIcon: React.FC<IStopIconProps> = memo(({ size }) => {
  return (
    <svg
      width={size || 16}
      height={size || 17}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 12.9183 3.58172 16.5 8 16.5ZM11 7.5H5V9.5H11V7.5Z"
        fill="#FF3838"
      />
    </svg>
  );
});

export { StopIcon };
